// ./src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Le tue traduzioni. Aggiungi qui tutte le stringhe che vuoi tradurre.
const resources = {
  en: {
    translation: {
      "loginPage": {
        "welcome": "Welcome to FlowDesk",
        "prompt": "Login to your account to continue",
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "loginButton": "Login",
        "loadingButton": "Logging in...",
        "forgotPassword": "Forgot password?",
        "registerPrompt": "Don't have an account? Request registration",
        "formRegistration": "Registration request",
        "formRegistrationDescription": "Select the account type and fill in the fields. Your request will be evaluated by an administrator.",
        "userType": "User Type",
        "companyName": "Company Name",
        "vatNumber": "VAT Number",
        "vatCountryCode": "Country",
        "firstName": "First Name",
        "lastName": "Last Name",
        "internal": "Internal",
        "customer": "Customer",
        "onlyNumbers": "Please enter numbers only",
        "registrationSuccess": "The outcome and credentials will be sent to this address.",
        "privacyPolicy": "I declare that I have read and understood",
        "privacyPolicyLink": "the privacy policy",
        "cancelButton": "Cancel",
        "submitButton": "Submit Request",
        "submittingButton": "Submitting...",
        "registrationSent": "Registration Sent",
        "registrationSuccessMessage": "Your registration request has been successfully sent. You will receive an email with instructions to complete the registration.",
        "registrationFailed": "Your registration request failed. Please try again later.",
        "loginFailed": "Login failed. Please check your credentials and try again.",
        "resetPassword": "Reset Password",
        "resetPasswordSuccess": "Your password has been successfully reset. Please check your email for instructions.",
        "resetPasswordInstructions": "Enter your email address. If it matches an existing account, we will send you a link to reset your password.",
        "resetPasswordEmailSent": "If the email address matches an existing account, we will send you a link to reset your password.",
        "emailSent": "Sent"
      },
      "publicDashboard": {
        "newOrderBtn": "New Order",
        "orderHistory": "Order History",
        "totalOrders": "{{count}} total orders",
        "filteredOrders": "{{filtered}} shown",
        "searchPlaceholder": "Search for product in orders...",
        "loadingOrders": "Loading orders...",
        "noOrdersFound": "No orders found",
        "noOrdersYet": "No orders yet",
        "noOrdersMatch": "There are no orders containing \"{{searchTerm}}\"",
        "ordersAppearHere": "When you place orders, they will appear here",
        "clearSearch": "Clear search",
        "orderLabel": "Order",
        "backToDashboard": "Back to Dashboard",
        "editableOnlyPending": "Editable only when \"Submitted\"",
        "editableOnlyPendingAlert": "Please note that orders can only be edited while they are in 'Submitted' status. Once processing has begun, modifications through the platform will no longer be possible.",
        "status": {
          "PENDING": "Submitted",
          "PROCESSING": "Received",
          "CONFIRMED": "Confirmed",
          "DELIVERED": "Delivered",
          "CANCELLED": "Canceled"
        },
        "item_one": "{{count}} item",
        "item_other": "{{count}} items",
        "vatIncluded": "(VAT incl.)",
        "plusVat": "+ VAT",
        "printSummary": "Print Order Summary",
        "requestAssistance": "Request Assistance",
        "editOrder": "Edit Order",
        "cancelOrder": "Cancel Order",
        "orderedProducts": "Products ordered:",
        "notes": "Notes:",
        "orderForm": {
          "createTitle": "Create New Order",
          "editTitle": "Edit Order {{orderNumber}}",
          "expiredOfferWarning": "Warning: the offers for the product \"{{productName}}\" are expired. The list price has been applied.",
          "requestQuoteBtn": "Request Quote",
          "shippingCostsTitle": "Shipping Costs",
          "shippingCostsInfo": "For orders below €{{threshold}}, shipping costs of €{{amount}} + VAT will be applied.",
          "addShippingBtn": "Add Shipping",
          "shippingProductUnavailable": "(Product for automatic addition is not available.)",
          "deliverySectionTitle": "1. Delivery Details",
          "deliveryAddressLabel": "Select a delivery address (optional)",
          "deliveryAddressHelper": "If the delivery address is not entered, the goods will be shipped to the legal address.",
          "noAddressFound": "No delivery addresses found.",
          "customerReferenceLabel": "Your Reference / P.O. Number (optional)",
          "customerReferenceHelper": "Your identifier which will be shown on the printout.",
          "productsSectionTitle": "2. Products",
          "addItemBtn": "Add Item",
          "generalNotesLabel": "General Order Notes",
          "taxableAmount": "Taxable Amount:",
          "vatAmount": "VAT 22%:",
          "orderTotal": "Order Total (VAT Included):",
          "cancelBtn": "Cancel",
          "saveChangesBtn": "Save Changes",
          "submitOrderBtn": "Submit Order",
          "quoteModalTitle": "Product Quote Request",
          "quoteModalText": "You are about to send a request for: <strong>{{productName}} - {{productDescription}}</strong>.<br/>You can edit the email body below before sending.",
          "sendRequestBtn": "Send Request",
          "sendingBtn": "Sending...",
          "greeting": "Dear BSN,",
          "body": "we are sending you a request for a quote for the product listed below. Please reply to this email with your best price.",
          "closing": "We look forward to your kind response and wish you a good day.",
          "signature": "Best Regards,\nThe FlowDesk Team",
          "productLabel": "Product",
          "notesPlaceholder": "Add any notes or questions here",
          "thanks": "Thank you",
          "closeBtn": "Close"
        },
        "orderItemRow": {
          "selectProduct": "Select Product",
          "refreshProducts": "Refresh product list",
          "quantity": "Quantity",
          "listPrice": "List Price",
          "discount": "Discount",
          "netPrice": "Net Price",
          "offeredPrice": "Offered Price",
          "rowTotal": "Row Total",
          "itemNotes": "Item Notes",
          "itemLabel": "Item {{index}}"
        },
        "alerts": {
          "error": "Error",
          "warning": "Warning",
          "success": "Success",
          "orderModified": "Order Modified!",
          "orderModifiedText": "The changes to your order have been saved.",
          "orderSubmitted": "Order Submitted!",
          "orderSubmittedText": "Your order has been submitted.",
          "areYouSure": "Are you sure?",
          "cancelOrderPrompt": "Do you want to cancel this order?",
          "confirmCancelBtn": "Yes, cancel it!",
          "orderCanceled": "Canceled!",
          "orderCanceledText": "The order has been canceled.",
          "cannotCancel": "Could not cancel the order.",
          "cannotLoadHistory": "Could not load order history.",
          "operationFailed": "Operation failed.",
          "addValidProduct": "Please add at least one valid product.",
          "shippingProductNotFound": "The product \"{{productName}}\" was not found in the list of available products. Please contact support.",
          "requestSent": "Sent!",
          "cannotSendRequest": "Could not send the request."
        },
        "printableOrder": {
          "title": "ORDER",
          "bsnRef": "(BSN Ref: #{{orderNumber}})",
          "datePrefix": "of",
          "platformMessage": "ORDER PROCESSED ON FLOWDESK B.S.N. PLATFORM",
          "companyName": "Company Name:",
          "vatNumber": "VAT Number:",
          "customerRef": "Your Reference/P.O.:",
          "deliveryAddress": "Delivery Address:",
          "defaultBillingAddress": "Legal address",
          "product": "Product",
          "description": "Description",
          "qty": "Qty",
          "listPrice": "List Price",
          "discount": "Discount %",
          "netPrice": "Net Price",
          "subtotal": "Subtotal",
          "freeGood": "Free",
          "freeGoodChip": "F.O.C.",
          "grossSubtotal": "Gross Subtotal:",
          "taxableAmount": "Taxable Amount:",
          "vatAmount": "VAT 22%:",
          "orderTotal": "ORDER TOTAL:",
          "notes": "Notes:",
          "docGenerated": "Document generated on {{date}}",
          "copy": "COPY {{copyType}}",
          "copyType": {
            "customer": "CUSTOMER",
            "bsn": "BSN"
          }
        },
        "orderChat": {
          "title": "Support for Order #{{orderNumber}}",
          "errorLoading": "Could not load the conversation.",
          "errorSending": "Could not send the message.",
          "errorDownloading": "Could not download the file. ({{errorMessage}})",
          "dropFilesHere": "Drop files here...",
          "attachmentsForOrder": "attachments_for_order_{{orderNumber}}.zip",
          "writeMessagePlaceholder": "Write a message or drag files here...",
          "authenticationTokenNotFound": "Authentication token not found."
        }
      }
    }
  },
  it: {
    translation: {
      "loginPage": {
        "welcome": "Benvenuto in FlowDesk",
        "prompt": "Accedi al tuo account per continuare",
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "loginButton": "Accedi",
        "loadingButton": "Accesso in corso...",
        "forgotPassword": "Password dimenticata?",
        "registerPrompt": "Non hai un account? Richiedi registrazione",
        "formRegistration": "Richiesta di registrazione",
        "formRegistrationDescription": "Seleziona il tipo di account e compila i campi. La tua richiesta sarà valutata da un amministratore.",
        "userType": "Tipo di Utente",
        "companyName": "Nome della Societa'",
        "vatNumber": "Partita IVA",
        "vatCountryCode": "Codice Nazione",
        "firstName": "Nome",
        "lastName": "Cognome",
        "internal": "Interno",
        "customer": "Cliente",
        "onlyNumbers": "Inserire solo i numeri",
        "registrationSuccess": "L'esito e le credenziali verranno inviate a questo indirizzo.",
        "privacyPolicy": "Dichiaro di aver letto e compreso",
        "privacyPolicyLink": "la privacy policy",
        "cancelButton": "Annulla",
        "submitButton": "Invia Richiesta",
        "submittingButton": "Invio in corso...",
        "registrationSent": "Registrazione Inviata",
        "registrationSuccessMessage": "La tua richiesta di registrazione è stata inviata con successo. Riceverai una email con le istruzioni per completare la registrazione.",
        "registrationFailed": "La tua richiesta di registrazione non è andata a buon fine. Riprova più tardi.",
        "loginFailed": "Accesso non riuscito. Controlla le tue credenziali e riprova.",
        "resetPassword": "Reimposta Password",
        "resetPasswordSuccess": "La tua password è stata reimpostata con successo. Controlla la tua email per le istruzioni.",
        "resetPasswordInstructions": "Inserisci il tuo indirizzo email. Se corrisponde a un account esistente, ti invieremo un link per reimpostare la tua password.",
        "resetPasswordEmailSent": "Se l'indirizzo email corrisponde a un account esistente, ti invieremo un link per reimpostare la tua password.",
        "emailSent": "Inviata"
      },
      "publicDashboard": {
        "newOrderBtn": "Nuovo Ordine",
        "backToDashboard": "Torna alla Dashboard",
        "editableOnlyPendingAlert": "Ti ricordiamo che gli ordini possono essere modificati esclusivamente quando si trovano nello stato 'Inviato'. Una volta presi in gestione, non sarà più possibile apportare modifiche via piattaforma.",
        "orderHistory": "Storico Ordini",
        "totalOrders": "{{count}} ordini totali",
        "filteredOrders": "{{filtered}} visualizzati",
        "searchPlaceholder": "Cerca prodotto negli ordini...",
        "loadingOrders": "Caricamento ordini...",
        "noOrdersFound": "Nessun ordine trovato",
        "noOrdersYet": "Nessun ordine presente",
        "noOrdersMatch": "Non ci sono ordini che contengano \"{{searchTerm}}\"",
        "ordersAppearHere": "Quando effettuerai degli ordini, appariranno qui",
        "clearSearch": "Cancella ricerca",
        "orderLabel": "Ordine",
        "status": {
          "PENDING": "Inviato",
          "PROCESSING": "Ricevuto",
          "CONFIRMED": "Confermato",
          "DELIVERED": "Consegnato",
          "CANCELLED": "Annullato"
        },
        "item_one": "{{count}} articolo",
        "item_other": "{{count}} articoli",
        "vatIncluded": "(IVA incl.)",
        "plusVat": "+ IVA",
        "printSummary": "Stampa Riepilogo Ordine",
        "requestAssistance": "Richiedi Assistenza",
        "editOrder": "Modifica Ordine",
        "cancelOrder": "Annulla Ordine",
        "orderedProducts": "Prodotti ordinati:",
        "notes": "Note:",
        "orderForm": {
          "createTitle": "Crea Nuovo Ordine",
          "editTitle": "Modifica Ordine {{orderNumber}}",
          "expiredOfferWarning": "Attenzione: le offerte per il prodotto \"{{productName}}\" sono scadute.",
          "requestQuoteBtn": "Richiedi Quotazione",
          "shippingCostsTitle": "Spese di Trasporto",
          "shippingCostsInfo": "Per ordini inferiori a €{{threshold}}, sono previste spese di trasporto di €{{amount}} + IVA.",
          "addShippingBtn": "Aggiungi Trasporto",
          "shippingProductUnavailable": "(Prodotto per aggiunta automatica non disponibile.)",
          "deliverySectionTitle": "1. Dettagli Spedizione",
          "deliveryAddressLabel": "Seleziona un indirizzo di consegna (opzionale)",
          "deliveryAddressHelper": "Se non viene inserito l'indirizzo di consegna la merce verrà spedita all'indirizzo della sede legale.",
          "noAddressFound": "Nessun indirizzo di consegna trovato.",
          "customerReferenceLabel": "Vs. Ordine (opzionale)",
          "customerReferenceHelper": "Il tuo identificativo che verrà mostrato in stampa.",
          "productsSectionTitle": "2. Prodotti",
          "addItemBtn": "Aggiungi Articolo",
          "generalNotesLabel": "Note Generali Ordine",
          "taxableAmount": "Imponibile:",
          "vatAmount": "IVA 22%:",
          "orderTotal": "Totale Ordine (IVA Inclusa):",
          "cancelBtn": "Annulla",
          "saveChangesBtn": "Salva Modifiche",
          "submitOrderBtn": "Invia Ordine",
          "quoteModalTitle": "Richiesta Quotazione Prodotto",
          "quoteModalText": "Stai per inviare una richiesta per: <strong>{{productName}} - {{productDescription}}</strong>.<br/>Puoi modificare il corpo dell'email qui sotto prima di inviare.",
          "sendRequestBtn": "Invia Richiesta",
          "sendingBtn": "Invio in corso...",
          "greeting": "Gentile Fornitore,",
          "body": "con la presente ti inviamo la richiesta di quotazione per il prodotto indicato qui sotto. Ti preghiamo di rispondere a questa email con il tuo miglior prezzo.",
          "closing": "Rimaniamo in attesa di un tuo gentile riscontro e ti auguriamo una buona giornata.",
          "signature": "Cordiali Saluti,\nIl Team di FlowDesk",
          "productLabel": "Prodotto",
          "notesPlaceholder": "Aggiungi qui eventuali note o domande",
          "thanks": "Grazie",
          "closeBtn": "Chiudi"
        },
        "orderItemRow": {
          "selectProduct": "Seleziona Prodotto",
          "refreshProducts": "Aggiorna lista prodotti",
          "quantity": "Quantità",
          "listPrice": "Listino",
          "discount": "Sconto",
          "netPrice": "Netto",
          "offeredPrice": "Prezzo Offerto",
          "rowTotal": "Totale Riga",
          "itemNotes": "Note articolo",
          "itemLabel": "Articolo {{index}}"
        },
        "alerts": {
          "error": "Errore",
          "warning": "Attenzione",
          "success": "Successo",
          "orderModified": "Ordine Modificato!",
          "orderModifiedText": "Le modifiche al tuo ordine sono state salvate.",
          "orderSubmitted": "Ordine Inviato!",
          "orderSubmittedText": "Il tuo ordine è stato inviato.",
          "areYouSure": "Sei sicuro?",
          "cancelOrderPrompt": "Vuoi annullare questo ordine?",
          "confirmCancelBtn": "Sì, annulla!",
          "orderCanceled": "Annullato!",
          "orderCanceledText": "L'ordine è stato annullato.",
          "cannotCancel": "Impossibile annullare l'ordine.",
          "cannotLoadHistory": "Impossibile caricare lo storico ordini.",
          "operationFailed": "Operazione fallita.",
          "addValidProduct": "Aggiungi almeno un prodotto valido.",
          "shippingProductNotFound": "Il prodotto \"{{productName}}\" non è stato trovato nella lista dei prodotti disponibili. Contattare l'assistenza.",
          "requestSent": "Inviato!",
          "cannotSendRequest": "Impossibile inviare la richiesta."
        },
        "printableOrder": {
          "title": "ORDINE",
          "bsnRef": "(Rif. BSN: #{{orderNumber}})",
          "datePrefix": "del",
          "platformMessage": "ORDINE PROCESSATO SU PIATTAFORMA FLOWDESK B.S.N.",
          "companyName": "Ragione Sociale:",
          "vatNumber": "P.IVA:",
          "customerRef": "Vs. Ordine:",
          "deliveryAddress": "Indirizzo Consegna:",
          "defaultBillingAddress": "Indirizzo della sede legale",
          "product": "Prodotto",
          "description": "Descrizione",
          "qty": "Qtà",
          "listPrice": "Listino",
          "discount": "Sconto %",
          "netPrice": "Prezzo Netto",
          "subtotal": "Subtotale",
          "freeGood": "Omaggio",
          "freeGoodChip": "S.M.",
          "grossSubtotal": "Subtotale Lordo:",
          "taxableAmount": "Imponibile:",
          "vatAmount": "IVA 22%:",
          "orderTotal": "TOTALE ORDINE:",
          "notes": "Note:",
          "docGenerated": "Documento generato il {{date}}",
          "copy": "COPIA {{copyType}}",
          "copyType": {
            "customer": "CLIENTE",
            "bsn": "BSN"
          }
        },
        "orderChat": {
          "title": "Assistenza per Ordine #{{orderNumber}}",
          "errorLoading": "Impossibile caricare la conversazione.",
          "errorSending": "Impossibile inviare il messaggio.",
          "errorDownloading": "Impossibile scaricare il file. ({{errorMessage}})",
          "dropFilesHere": "Rilascia i file qui...",
          "attachmentsForOrder": "allegati_ordine_{{orderNumber}}.zip",
          "writeMessagePlaceholder": "Scrivi un messaggio o trascina i file...",
          "authenticationTokenNotFound": "Token di autenticazione non trovato."
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;